import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { useNavigation } from '../../main';
import { RouterLink, RouterLinkProps } from './RouterLink';
import { StyledLink } from './StyledLink';

export interface LinkProps extends Omit<RouterLinkProps, 'navigationHook'> {
  /** Specifies what the routing will be performed relative to.
   * Examples below with service path 'test' and root url 'scp':
   *
   *-default: use href props of link
   *
   *-global: use platform instance of react-router-dom. Redirect to '/' will result 'scp';
   *
   *-inner: use current instance of react-router-dom. Redirect to '/' will result  'scp/test'.
   */
  navigationType?: 'inner' | 'global' | 'default';
}

/**
 * @description Link component
 */
export function Link({
  navigationType = 'default',
  ...rest
}: LinkProps): ReactElement {
  if (navigationType === 'default') return <StyledLink {...rest} />;

  const navigationHook =
    navigationType === 'inner' ? useNavigate : useNavigation;

  return <RouterLink {...rest} navigationHook={navigationHook} />;
}
